export default __webpack_public_path__ + "static/1-pointers-92a337c8f17e3ed06fe8041aeb5fa0d8.png";